import DateRange from "./DateRange";
import TimeRange from "./TimeRange";
import DateRangeInput from "./DateRangeInput";
import TimeRangeInput from "./TimeRangeInput";

const DatePicker = { DateRange, TimeRange, DateRangeInput, TimeRangeInput };

export default DatePicker;
